<template>
  <sl-table ref="table" :loading="loading" :enable-pager="false" :columns="columns" :data="data"></sl-table>
</template>
<script>
export default {
  data() {
    return {
      columns: [{
          title: '被授信人名称',
          key: 'displayName'
        },
        {
          title: '被授信人编码',
          key: 'displayCode'
        },
        {
          title: '授信公司',
          key: 'creditCompanyName'
        },
        {
          title: '订单编号',
          key: 'orderNo'
        },
        {
          title: '审批状态',
          key: 'stateText'
        },
        {
          title: '创建时间',
          key: 'createDatetimeText'
        }
      ],
      data: [],
      loading: false
    }
  },
  props: {
    actions: {
      default: function() {
        return []
      }
    },
    personId:{

    }
  },
  created() {
    this.def = { ...this.params }
    this.columns.push(...this.actions)
    if(this.personId) this.list()
  },
  watch:{
    personId(nv){
      if(nv){
        this.list()
      }
    }
  },
  methods: {
    init(id){
      this.personId = id
      this.list()
    },
    list() {
      // let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.ciPersonHistories(this.personId).then(resp => {
        this.loading = false
        if (!resp.code) {
          // this.data = this.$utils.conv(resp.data.list || [], { 'createDatetime': 'time' , 'enterpriseType':'$enterpriseType', 'companyType':'$companyType','state':'$state'})
          this.data = this.$utils.merge(this.$utils.conv(resp.data || [], { 'createDatetime': 'time', 'state': '$loanState', 'companyType': '$companyType' }), { 'enterpriseName': 'displayName', 'personalName': 'displayName', 'enterpriseCode': 'displayCode', 'personalCode': 'displayCode' })

          //this.page.total = resp.data.total || 0
        }
      })
    }
  }
}

</script>
